// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"fe7f529baf24cb06f1d3","655":"76339b9da0d629b16abb"}[chunkId] + ".js";
};